/* Copyright 2013 The MathWorks, Inc. */

/**
 * This is a list of the component types that can be added to the Footer. The keys are the Component type that can be added
 * to the Footer, the value is the type it transforms to.
 */

define([
    "../constants/TypeConstants"
],
    function (TypeConstants) {
        return [
            TypeConstants.PUSH_BUTTON,
            TypeConstants.TOGGLE_BUTTON,
            TypeConstants.RADIO_BUTTON,
            TypeConstants.TEXT_FIELD,
            TypeConstants.LABEL,
            TypeConstants.CHECK_BOX
        ];
    });
